import { useState } from "react";

import Grid2 from "@mui/material/Grid2";
import LinearProgress from "@mui/material/LinearProgress";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Lottie from "lottie-react";

import { LidJarOff, LidJarOn, LidOffJarOn } from "../../utils/iconRefs/miniPlayerIcons"
import { BladeLottie, FlameLottie } from "../../utils/lottieRefs";
import { AppHardwareStatusEnum } from "./Miniplayer";
import styles from "./miniPlayerContent.module.css";

const SUBSTEP_TYPE = {
    INSTRUCTION: 'instruction',
}

const LOCATION = {
    JAR: 'jar',
    BOWL: 'bowl',
}


const RenderLocation = ({ substepType, location }: { substepType: string, location: string }) => {
    if (substepType === SUBSTEP_TYPE.INSTRUCTION || location === LOCATION.JAR) {
        return <span>In the Jar</span>;
    } if (location === LOCATION.BOWL) {
        return <span>In a Bowl</span>;
    }
    return null;
};

const TimerDisplay = ({ time }: { time: string }) => (
    <Grid2
        className={styles.timer_display}
    >
        <Typography variant="caption3Bold">
            {time}
        </Typography>

    </Grid2>
)

const IconCircle = ({ lidOn, jarOn, expandedUI }: { lidOn: boolean, jarOn: boolean, expandedUI: boolean }) => {
    const getIcon = () => {
        if (lidOn && jarOn) {
            return <LidJarOn />;
        }
        if (!lidOn && jarOn) {
            return <LidOffJarOn />;
        }
        return <LidJarOff />;
    };

    const icon = getIcon();
    return (
        <div className={expandedUI ? styles.icon_circle_bottom : styles.icon_circle_top}>
            {icon}
        </div>
    );
};

const MiniplayerContent = ({ recipeName, parsedProgress, stateOfHardware, recipeStatus, shouldShowProgess, time, jarOn, lidOn, substepName, location, substepType }: {
    recipeName: string,
    parsedProgress: number,
    stateOfHardware: AppHardwareStatusEnum,
    recipeStatus: string,
    shouldShowProgess: boolean,
    time: string,
    jarOn: boolean,
    lidOn: boolean,
    substepName: string,
    location: string,
    substepType: string,
}) => {
    const [expandedUI, setExpandedUI] = useState(false);
    const handleToggle = () => {
        setExpandedUI((prev) => !prev);
    }
    return (
        <Paper
            className={expandedUI ? styles.paper_container_expanded : styles.paper_container}
            elevation={expandedUI ? 0 : 3}
            onClick={handleToggle}
        >
            {!expandedUI ? <IconCircle expandedUI={expandedUI} jarOn={jarOn} lidOn={lidOn} /> : null}
            <Grid2 className={styles.main_grid}>
                <Grid2
                    container
                    gap={2}
                >
                    {expandedUI ? (
                        <Typography
                            className={styles.miniplayer_typography_color}
                            variant="miniPlayerText"
                        >
                            {`Cooking: ${recipeName}`}
                        </Typography>
                    ) : null}
                    <Typography
                        className={styles.miniplayer_typography_color}
                        variant="miniPlayerText"
                    >
                        <RenderLocation substepType={substepType} location={location} /> : {substepName}
                    </Typography>
                </Grid2>

                {shouldShowProgess ? (
                    <Grid2 alignItems="center" container justifyContent="space-between">
                        <LinearProgress
                            className={styles.linear_progress}
                            sx={{
                                '& .MuiLinearProgress-bar': {
                                    borderRadius: 3,
                                    backgroundColor: '#0F204D',
                                },
                            }}
                            value={parsedProgress || 0}
                            variant="determinate"
                        />
                        {!expandedUI ? (
                            <TimerDisplay time={time} />
                        ) : <IconCircle expandedUI={expandedUI} jarOn={jarOn} lidOn={lidOn} />}
                    </Grid2>
                ) : null}

                {expandedUI && (stateOfHardware === AppHardwareStatusEnum.OPERATION) && (
                    <>
                        <Grid2 alignItems="center" container gap={2}>
                            <Lottie animationData={BladeLottie} loop />
                            <Lottie animationData={FlameLottie} loop />
                            <TimerDisplay time={time} />
                        </Grid2>

                    </>
                )}
            </Grid2>
        </Paper >
    );
}
export default MiniplayerContent;
